"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APButton = void 0;
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var react_1 = __importDefault(require("react"));
function APButton(_a) {
    var children = _a.children, _b = _a.color, color = _b === void 0 ? "default" : _b, _c = _a.size, size = _c === void 0 ? "medium" : _c, _d = _a.variant, variant = _d === void 0 ? "outlined" : _d, style = _a.style, onClick = _a.onClick, disabled = _a.disabled;
    return (react_1.default.createElement(Button_1.default, { disabled: disabled, color: color, size: size, variant: variant, style: style, onClick: onClick }, children));
}
exports.APButton = APButton;
